<template>
	<Space v-bind="{ ...$attrs, ...$props }" class="allow-wrap">
		<slot></slot>
	</Space>
</template>

<script>
import { Space } from 'ant-design-vue';

// Вся идея компонента в том, чтобы происходил перенос строк, если не хватает места.
// size: 'small', 'middle', 'large', Number

export default {
	components: {
		Space,
	},
}
</script>

<style scoped>
.allow-wrap {
	flex-wrap: wrap;
}
</style>
